import { fromJS } from 'immutable';

import { fetchReportRoutine } from '../routines';

const initialState = fromJS({
  reports: {},
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchReportRoutine.SUCCESS:
      return state.setIn([action.payload.request.report], fromJS(action.payload.response || {}));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reports.js